import React, { FC, ReactNode } from 'react';
import { HeaderElem } from './Header.styles';
import Title from './Title/Title';
import SectionTabs from '../../../../../components/SectionTabs/SectionTabs';

interface IHeaderProps {
  children: ReactNode;
  className?: string;
}

interface IHeader extends FC<IHeaderProps> {
  Title: typeof Title;
  Tabs: typeof SectionTabs;
}

// eslint-disable-next-line react/prop-types
const Header: IHeader = ({ children, className }) => (
  <HeaderElem id="HeaderElem" {...{ className }}>
    {children}
  </HeaderElem>
);

Header.Title = Title;
Header.Tabs = SectionTabs;

export default Header;
